import React, { useMemo } from 'react';

import { SystemProperty } from '@/components/FilterManager/Tags/TagsAndProperties/types';
import { FilterOperatorEnum, FilterPropertyTypeEnum, TagTypeEnum, TagUnion } from '@/types/schema';

import ContentTypeFilter from './ContentTypeFilter';
import DateSelectFilter from './DateSelectFilter';
import DepartmentFilter from './DepartmentFilter';
import InputFilter from './InputFilter';
import NumberFilter from './NumberFilter';
import OrgRoleFilter from './OrgRoleFilter';
import SessionTypeFilter from './SessionTypeFilter';
import TagValueSelector from './TagValueSelector';
import UserFilter from './UserFilter';

interface FilterValuesProps {
  propertyType?: FilterPropertyTypeEnum;
  propertyValue?: string;
  tag?: TagUnion | null;
  onFilterValueChange: (value?: string) => void;
  filterValue?: string;
  disabled: boolean;
  error?: boolean;
  operator?: FilterOperatorEnum;
  disableDateValueTypeSelector?: boolean;
  className?: string;
  isConditionalDrip?: boolean;
}
const RenderAs = {
  [TagTypeEnum.Date]: DateSelectFilter,
  [TagTypeEnum.MultiSelect]: TagValueSelector,
  [TagTypeEnum.SingleSelect]: TagValueSelector,
  [TagTypeEnum.Number]: NumberFilter,
  [TagTypeEnum.Text]: InputFilter,
  [TagTypeEnum.User]: UserFilter,
};

const RenderSystemProperties = {
  [SystemProperty.OrgRoleId]: OrgRoleFilter,
  [SystemProperty.DepartmentId]: DepartmentFilter,
  [SystemProperty.ManagerId]: UserFilter,
  [SystemProperty.IndirectManagerId]: UserFilter,
  [SystemProperty.CreatedById]: UserFilter,
  [SystemProperty.CreatedAt]: DateSelectFilter,
  [SystemProperty.Type]: ContentTypeFilter,
  [SystemProperty.Email]: InputFilter,
  [SystemProperty.EventType]: SessionTypeFilter,
  [SystemProperty.EventDate]: DateSelectFilter,
};

function FilterValues(props: FilterValuesProps) {
  const {
    propertyValue,
    propertyType,
    tag,
    filterValue,
    onFilterValueChange,
    disabled,
    error,
    operator,
    disableDateValueTypeSelector,
    className,
    isConditionalDrip = false,
  } = props;

  let RenderComponent = useMemo(() => {
    if (propertyType === FilterPropertyTypeEnum.Tag && tag) {
      return RenderAs[tag.type];
    }
    if (propertyType === FilterPropertyTypeEnum.Field) {
      return RenderSystemProperties[propertyValue as SystemProperty];
    }
    if (
      (propertyType === FilterPropertyTypeEnum.Question ||
        propertyType === FilterPropertyTypeEnum.Content) &&
      isConditionalDrip
    ) {
      return RenderAs[TagTypeEnum.Number];
    }
    return InputFilter;
  }, [isConditionalDrip, propertyType, propertyValue, tag]);

  return (
    <RenderComponent
      className={className}
      disableDateValueTypeSelector={disableDateValueTypeSelector}
      disabled={disabled}
      error={error}
      filterValue={filterValue}
      operator={operator}
      tag={tag}
      onFilterValueChange={onFilterValueChange}
    />
  );
}

export default FilterValues;
